export const home = {
    hero: {
        badge: 'Líder en Tecnología de Drones',
        title: {
            line1: 'Soluciones en Drones',
            line2: 'para Agricultura',
        },
        description: 'Ofrecemos drones profesionales de alta calidad y asistencia técnica especializada en drones agrícolas. Tecnología de vanguardia para maximizar su productividad.',
        features: {
            feature1: 'Drones profesionales certificados',
            feature2: 'Asistencia técnica especializada',
            feature3: 'Soporte técnico completo',
        },
        cta: {
            primary: 'Ver Catálogo',
            secondary: 'Contáctenos',
        },
        image: {
            alt: 'Drone profesional para agricultura',
        },
    },
    footer: {
        company: {
            name: 'Fronteira Sul Drones',
            description: 'Especialistas en drones profesionales y asistencia técnica para drones agrícolas. Ofrecemos tecnología de vanguardia, mantenimiento especializado y soluciones personalizadas para maximizar la productividad de su negocio.',
        },
        badges: {
            experience: 'Años de Experiencia',
            quality: 'Calidad Garantizada',
        },
        sections: {
            quickLinks: 'Enlaces Rápidos',
            contact: 'Contacto',
        },
        links: {
            home: 'Inicio',
            newDrones: 'Drones Nuevos',
            usedDrones: 'Drones Usados',
            services: 'Servicios',
            about: 'Acerca de',
            contact: 'Contacto',
        },
        contact: {
            hours: {
                weekdays: 'Lunes a Viernes: {{start}} a {{end}}',
                saturday: 'Sábado: {{start}} a {{end}}',
            },
        },
        copyright: '© {{year}} Fronteira Sul Drones. Todos los derechos reservados.',
        madeBy: {
            label: 'Hecho por',
            ariaLabel: 'Hecho por AttoDev',
        },
    },
    about: {
        badge: 'Acerca de Nosotros',
        title: {
            part1: 'Conoce a',
            part2: 'Fronteira Sul Drones',
        },
        description: {
            paragraph1: 'Fronteira Sul Drones es una empresa especializada en soluciones tecnológicas para la agricultura, ofreciendo drones profesionales de alta calidad y asistencia técnica especializada en drones agrícolas.',
            paragraph2: 'Con años de experiencia en drones de pulverización agrícola, nuestra misión es proporcionar tecnología de vanguardia que maximice la productividad y eficiencia de nuestros clientes, priorizando siempre la calidad, seguridad e innovación.',
            paragraph3: 'Trabajamos con equipos certificados y un equipo altamente calificado, garantizando resultados excepcionales en cada proyecto.',
        },
        values: {
            title: 'Nuestros Valores',
            quality: 'Calidad',
            innovation: 'Innovación',
            reliability: 'Confiabilidad',
            excellence: 'Excelencia',
        },
    },
    newDrones: {
        badge: 'Gama Profesional',
        title: 'Drones Nuevos',
        subtitle: 'Tecnología de vanguardia para sus necesidades',
        viewCatalog: 'Ver Catálogo Completo',
        features: 'Características',
        inStock: 'En Stock',
        outOfStock: 'Agotado',
        noProducts: 'Actualmente no tenemos drones nuevos disponibles. Por favor, vuelva pronto o contáctenos.',
    },
    usedDrones: {
        badge: 'Oportunidad Verificada',
        title: 'Drones Usados',
        subtitle: 'Calidad garantizada con mejor relación calidad-precio',
        viewCatalog: 'Ver Catálogo Completo',
        condition: 'Condición',
        features: 'Características',
        inStock: 'En Stock',
        outOfStock: 'Agotado',
        noProducts: 'Actualmente no tenemos drones usados disponibles. Consulte nuestro catálogo de drones nuevos.',
    },
    buffalo: {
        badge: 'Motores y Acoplados',
        title: 'Línea Buffalo',
        subtitle: 'Excelencia en motores y soluciones para todo Brasil',
        viewCatalog: 'Ver Catálogo Línea Buffalo',
        noProducts: 'Pronto tendremos productos de la Línea Buffalo disponibles en el catálogo.',
    },
    powerCitros: {
        badge: 'Ultra Limpiador Cítrico',
        title: 'Power Citros',
        subtitle: 'El único producto que necesita para limpiar todo — drones, vehículos, equipos agrícolas y más. Fórmula biodegradable de alto rendimiento.',
        viewCatalog: 'Ver Productos Power Citros',
        noProducts: 'Próximamente tendremos los productos Power Citros disponibles en el catálogo.',
    },
    parts: {
        badge: 'Piezas Originales',
        title: 'Piezas y Accesorios',
        subtitle: 'Encuentre las mejores piezas originales y accesorios para su equipo',
        viewCatalog: 'Ver Catálogo de Piezas',
        noProducts: 'Próximamente tendremos piezas disponibles en nuestro catálogo online.',
    },
    spraying: {
        badge: 'Servicios Especializados',
        title: {
            part1: 'Asistencia Técnica y Mantenimiento',
            part2: 'en Drones Agrícolas',
        },
        subtitle: 'Servicios especializados de asistencia técnica y mantenimiento para drones agrícolas. Equipo calificado y piezas originales para garantizar el máximo rendimiento de sus equipos.',
        description: {
            paragraph1: 'Ofrecemos asistencia técnica completa y servicios de mantenimiento preventivo y correctivo para drones agrícolas, con enfoque en mantener sus equipos siempre en perfecto estado de funcionamiento.',
            paragraph2: 'Nuestro equipo está compuesto por técnicos altamente calificados, con amplia experiencia en drones agrícolas y certificaciones para trabajar con equipos de última generación.',
            paragraph3: 'Trabajamos con piezas originales, realizamos diagnósticos precisos y ofrecemos soporte técnico completo para maximizar la vida útil y el rendimiento de sus drones.',
        },
        benefits: {
            title: 'Beneficios',
            precision: 'Diagnóstico Preciso',
            efficiency: 'Mantenimiento Rápido',
            safety: 'Piezas Originales',
            technology: 'Técnicos Certificados',
        },
        services: {
            title: 'Nuestros Servicios',
            mapping: 'Mantenimiento preventivo e inspecciones periódicas completas',
            calibration: 'Calibración y configuración de sistemas de pulverización y sensores',
            application: 'Reparación y sustitución de piezas con componentes originales',
            support: 'Soporte técnico especializado y capacitación de operadores',
        },
        equipment: {
            title: 'Equipos',
            description: 'Utilizamos drones XAG P100 Pro con tecnología RTK, garantizando precisión y eficiencia en todas las operaciones.',
            certified: 'Certificado MAPA',
        },
        cta: {
            button: 'Solicitar Presupuesto',
            description: 'Contáctenos y solicite un presupuesto personalizado para su propiedad',
        },
    },
    metrics: {
        title: 'Nuestros Números',
        subtitle: 'Resultados que demuestran nuestra experiencia y compromiso con la excelencia en el agronegocio',
        hectares: 'Hectáreas Pulverizadas',
        clients: 'Clientes Atendidos',
        experience: 'Años de Experiencia',
        drones: 'Drones Operacionales',
        economy: 'Ahorro de Defensivos',
        precision: 'Precisión de Aplicación',
        suffix: {
            hectares: '+ ha',
            clients: '+',
            years: ' años',
            drones: ' unidades',
            economy: '%',
            precision: '%',
        },
    },
    contact: {
        badge: 'Contáctenos',
        title: 'Hable Con Nosotros',
        subtitle: 'Estamos listos para ayudarle a encontrar la mejor solución en drones',
        whatsapp: {
            title: 'WhatsApp',
            description: 'Hable con nosotros directamente por WhatsApp',
            button: 'Chatear en WhatsApp',
            cta: 'Respuesta rápida y atención personalizada',
        },
        other: {
            title: 'Otros Medios de Contacto',
            email: {
                label: 'Correo Electrónico',
            },
            phone: {
                label: 'Teléfono',
            },
            address: {
                label: 'Dirección',
            },
            hours: {
                label: 'Horario de Atención',
            },
        },
    },
    productCard: {
        featured: 'Destacado',
        buy: 'Comprar',
        types: {
            new: 'Edición Pro',
            used: 'Calidad Verificada',
            buffalo: 'Línea Buffalo',
            'power-citros': 'Power Citros',
            parts: 'Pieza Original',
        },
    },
};
//# sourceMappingURL=home.js.map